module.exports = __webpack_public_path__ + "img/my-car.30e23b15.png";